import { AstaSettings, AstaResultatStatusType } from './types/AstaTypes';
type UHRGlobal = {
  ready: (callback: (window: Window, $: JQueryStatic) => void) => void;
  filters?: { init: () => void };
};
declare global {
  const uhr: UHRGlobal;
  //const jQuery: JQueryStatic;
  const AstaResultatStatus: AstaResultatStatusType;
  const Asta: AstaSettings;
  interface Window {
    Cookies: any;
    uhr: UHRGlobal;
  }
}

import './Static/Scripts/jquery.reflowcolumns.js'; //main.js
import './Static/Scripts/jquery.resizeend.mod.js'; //sunburstchart
import './Static/Scripts/jquery.simplefilter.js'; //countryselectorblock
import './Static/Scripts/jquery.citetofootnote.js'; //main
import './Static/Bootstrap/js/bootstrap.js';
import './Static/Scripts/autocomplete.js'; // This one is for "normal" search
import './Static/uhrdictionary/autocomplete.js'; // This one is for the dictionary
import './Static/Scripts/progress-circle.js';

//site
import './Static/Scripts/site/education-comparison.js';
import './Static/Scripts/site/foreigngradecalculator.js';
import './Static/Scripts/site/navigation.js';
import './Static/Scripts/site/resursbanken.js';
import './Static/Scripts/site/filterpanelblock.js';
import './Static/Scripts/site/sunburstchart.js';
import './Static/Scripts/site/searchpage.js';
import './Static/Scripts/site/searchevaluationpage.js';
import './Static/Scripts/site/altarnativeselectionform.js';
import './Static/Scripts/site/countryselectorblock.js';
import './Static/Scripts/site/iframe-uhr.js';
import './Static/Scripts/site/main.js'; //SKA MÄ

import './Static/Scripts/site/mediablock.js';
import './Static/Scripts/site/columnbasedlandingpage.js';
import './Static/Scripts/antagningsstatistik.sokblock.js';
import './Static/Scripts/programpagelist.js';
import Cookies from 'js-cookie';

import './vue-start.ts';

import './Static/Styles/Bootstrap.custom.less';
import './Static/Styles/Site.less';
import './Static/Styles/cssthemes/syv/theme.less';

import './Static/Styles/Print.less';

window.Cookies = Cookies;

//import followSidebar from './Scripts/site/follow-sidebar.js';
//justera så den använder importen och initieras med uhr.ready. men efter omflytt av filer

uhr.ready((_w, $) => {
  if ($('.letter-selector')[0]) {
    var element = $('.letter-selector');
    if (element) {
      const originalY = element.offset()?.top;

      $(window).on('scroll', function (_event: any) {
        var scrollTop = $(window).scrollTop();

        if (originalY)
          $(window).scroll(function () {
            if (scrollTop && scrollTop > originalY - 25) {
              $('.letter-selector').addClass('letter-selector-fixed');
            } else {
              $('.letter-selector').removeClass('letter-selector-fixed');
            }
          });
      });
    }
  }
});
